import React, { useState } from "react";
import { NavLink } from "react-router-dom";

const Navbar = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [openDropdown, setOpenDropdown] = useState(null);

  const menuItems = [
    { name: "मुखपृष्ठ", path: "/" },
    {
      name: "ग्रापंचायत विषयी",
      dropdown: [
        { name: "परिचय", path: "/grampanchayatinfo" },
        { name: "दृष्टी आणि ध्येय", path: "/drushtianidhyey" },
        // { name: "जबाबदाऱ्या", path: "/grampanchayat/responsibilities" },
      ],
    },
    {
      name: "गाव विषयी",
      dropdown: [
        { name: "व्यायामशाळा", path: "/vyayam-shala" },
        { name: "शाळा", path: "/shala" },
        { name: "वाचनालय", path: "/vachanalay" },
        { name: "मंदिरे", path: "/temples" },
      ],
    },
    {
      name: "कार्यक्रम/योजना",
      dropdown: [
        { name: "कार्यक्रम", path: "/programs/programs" },
        { name: "योजना", path: "/programs/schemes" },
      ],
    },
    {
      name: "कागदपत्रे",
      dropdown: [
        { name: "शासन निर्णय", path: "/shasannirnay" },
        { name: "अधिसूचना", path: "/adhisuchana" },
      ],
    },

    {
      name: "सूचना",
      dropdown: [
        { name: "अधिसूचना", path: "/adhisuchana" },
        { name: "ग्रापंचायत सूचना", path: "/grampanchayat-suchana" },
      ],
    },
    { name: "कर भरणा", path: "/karbharna" },
    { 
        name: "नागरिकां विषयी", 
        dropdown:[
            { name: "तक्रार निवारण पोर्टल", path: "/takrarnivaranportal" }
        ]
    },
    {
      name: "माहितीचा अधिकार",
      dropdown: [
        { name: "माहितीचा अधिकार कागदपत्रे", path: "/rti" },
        { name: "तंत्रमुक्ती केंद्र", path: "/rti/tantamukti" },
      ],
    },
  ];

  return (
    <nav className="bg-custom-bg border-b text-black">
      <div className="max-w-7xl mx-auto px-4">
        <div className="flex justify-between h-12 items-center">

          {/* Desktop Menu */}
          <div className="hidden md:flex h-full">
            {menuItems.map((item, index) => (
              <div key={index} className="relative h-full">
                {item.dropdown ? (
                  <>
                    <button
                      className="h-full px-4 flex items-center text-gray-800 font-semibold text-sm hover:bg-custom-orange hover:text-black transition-colors duration-200 w-full"
                      onClick={() =>
                        setOpenDropdown(openDropdown === index ? null : index)
                      }
                    >
                      {item.name}
                      <span className="ml-1">&#x25BC;</span>
                    </button>
                    {openDropdown === index && (
                      <div className="absolute left-0 bg-custom-orange shadow-lg rounded-md mt-1 z-10 min-w-full">
                        {item.dropdown.map((sub, i) => (
                          <NavLink
                            key={i}
                            to={sub.path}
                            className={({ isActive }) =>
                              `block px-4 py-2 w-full ${
                                isActive
                                  ? "bg-orange-400 text-black font-semibold"
                                  : "text-black hover:bg-orange-300"
                              }`
                            }
                            onClick={() => setOpenDropdown(null)}
                          >
                            {sub.name}
                          </NavLink>
                        ))}
                      </div>
                    )}
                  </>
                ) : (
                  <NavLink
                    to={item.path}
                    className={({ isActive }) =>
                      `h-full flex items-center px-4 text-sm font-semibold w-full transition-colors duration-200 ${
                        isActive
                          ? "bg-custom-orange text-black"
                          : "text-gray-800 hover:bg-custom-orange hover:text-black"
                      }`
                    }
                  >
                    {item.name}
                  </NavLink>
                )}
              </div>
            ))}
          </div>

          {/* Mobile menu button */}
          <div className="md:hidden">
            <button
              onClick={() => setIsOpen(!isOpen)}
              className="text-gray-700 focus:outline-none text-lg font-bold"
            >
              ☰
            </button>
          </div>
        </div>
      </div>

      {/* Mobile Menu */}
      {isOpen && (
        <div className="md:hidden bg-white px-4 pb-4 shadow-lg">
          {menuItems.map((item, index) => (
            <div key={index} className="border-b py-2">
              {item.dropdown ? (
                <>
                  <button
                    className="w-full text-left text-gray-800 font-medium text-sm px-4 py-2 hover:bg-custom-orange hover:text-black transition-colors duration-200"
                    onClick={() =>
                      setOpenDropdown(openDropdown === index ? null : index)
                    }
                  >
                    {item.name} <span className="ml-1">&#x25BC;</span>
                  </button>
                  {openDropdown === index && (
                    <div className="pl-4 mt-1 space-y-1">
                      {item.dropdown.map((sub, i) => (
                        <NavLink
                          key={i}
                          to={sub.path}
                          className={({ isActive }) =>
                            `block text-sm px-4 py-2 w-full border-b last:border-b-0 ${
                              isActive
                                ? "bg-orange-400 text-black font-semibold"
                                : "text-black hover:bg-orange-300"
                            }`
                          }
                          onClick={() => {
                            setOpenDropdown(null);
                            setIsOpen(false);
                          }}
                        >
                          {sub.name}
                        </NavLink>
                      ))}
                    </div>
                  )}
                </>
              ) : (
                <NavLink
                  to={item.path}
                  className={({ isActive }) =>
                    `w-full text-left text-sm font-medium px-4 py-2 rounded transition-colors duration-200 ${
                      isActive
                        ? "bg-custom-orange text-black"
                        : "text-gray-800 hover:bg-custom-orange hover:text-black"
                    }`
                  }
                  onClick={() => setIsOpen(false)}
                >
                  {item.name}
                </NavLink>
              )}
            </div>
          ))}
        </div>
      )}
    </nav>
  );
};

export default Navbar;
